module.exports = __webpack_public_path__ + "static/media/prestashop.55fbfce6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/prestashop.svg
// module id = 2164
// module chunks = 1